import { post } from '../../../../DAL/data-provider';
import { IConfirmOrderRequest, IConfirmOrderWithoutLeftSideRequest, ILocalDataRequest } from '../interfaces';

export const createCashierToken = async () => {
    return post('/api/bridgerpay/create-cashier-token', {});
};

/**
 * get shopping cart data
 */
export const getData = async (localData?: ILocalDataRequest) => {
    return post('/api/shoppingcart/get-data', {
        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

/**
 * add cart item
 */
export const addCartItem = async (
    skuId: number,
    localData?: ILocalDataRequest
) => {
    return post('/api/shoppingcart/add-cart-item', {
        skuId,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

/**
 * update qty
 */
export const updateQuantity = async (
    cartItemGUID: string,
    units: number,
    localData?: ILocalDataRequest
) => {
    return post('/api/shoppingcart/update-qty', {
        cartItemGUID,
        units,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

/**
 * remove cart item
 */
export const removeCartItem = async (
    cartItemGUID: string,
    localData?: ILocalDataRequest
) => {
    return post('/api/shoppingcart/remove', {
        cartItemGUID,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

/**
 * add coupons
 */
export const addCoupons = async (
    coupons: string[],
    localData?: ILocalDataRequest
) => {
  return post('/api/coupons/add-coupon', {
      coupons,

      shipAddressLine: localData?.shipAddressLine,
      shipCity: localData?.shipCity,
      shipZipCode: localData?.shipZipCode,
      shipCountry2LetterCode: localData?.shipCountry2LetterCode,
      shipState2LetterCode: localData?.shipState2LetterCode,
      shippingCode: localData?.shippingCode,

      taxCountry2LetterCode: localData?.taxCountry2LetterCode,
      taxState2LetterCode: localData?.taxState2LetterCode,
      taxZipCode: localData?.taxZipCode,
      taxID: localData?.taxID,

      step: localData?.step,
  });
};

/**
 * remove coupons
 */
export const removeCoupons = async (
    coupons: string[],
    localData?: ILocalDataRequest
) => {
    return post('/api/coupons/remove-coupon', {
        coupons,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

export const addCredit = async (
    credit: number,
    // useCreditRecurring: boolean,
    localData?: ILocalDataRequest
) => {
    return post('/api/credit/add', {
        credit,
        // useCreditRecurring,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

export const removeCredit = async (localData?: ILocalDataRequest) => {
    return post('/api/credit/remove', {
        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,

        step: localData?.step,
    });
};

/**
 * get a list of saved credit cards (if there are any)
 */
export const getSavedCreditCards = async () => {
    return post('/api/bridgerpay/get-saved-cards', {});
};

/**
 * remove saved credit cart
 * it maybe in use with subscription, in this case it won't be removed
 */
export const removeSavedCreditCard = async (token: string) => {
    return post('/api/bridgerpay/remove-saved-card', {
        token,
    });
};

/**
 * perform confirm order
 */
export const confirmOrder = async (model: IConfirmOrderRequest) => {
    return post('/api/bridgerpay/confirm-order', model);
};

export const confirmOrderWithoutLeftSide = async (model: IConfirmOrderWithoutLeftSideRequest) => {
    return post('/api/bridgerpay/confirm-order-wl', model);
};

/**
 * get current shopping cart tax
 */
export const getTax = async (
    localData?: ILocalDataRequest
) => {
    return post('/api/shoppingcart/get-tax', {
        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,
    });
};

/**
 * get UPS shipping options for the shipping drop-down
 */
export const getShippingOptions = async (localData?: ILocalDataRequest) => {

    return post('/api/shoppingcart/get-shipping-options', {
        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,
    });
};

/**
 * get updated cart data when shipping option changes
 */
export const updateShippingCode = async (localData?: ILocalDataRequest) => {
    return post('/api/shoppingcart/update-shipping-code', {
        shippingCode: localData?.shippingCode,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,
    });
};

export const enableDisableCartItem = async (cartItemGUID: string, localData?: ILocalDataRequest) => {
    return post('/api/shoppingcart/enable-disable-cart-item', {
        cartItemGUID,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,
    });
};

export const selectCartGroup = async (cartGroupID: number, localData?: ILocalDataRequest) => {
    return post('/api/shoppingcart/select-cart-group', {
        cartGroupID,

        shipAddressLine: localData?.shipAddressLine,
        shipCity: localData?.shipCity,
        shipZipCode: localData?.shipZipCode,
        shipCountry2LetterCode: localData?.shipCountry2LetterCode,
        shipState2LetterCode: localData?.shipState2LetterCode,
        shippingCode: localData?.shippingCode,

        taxCountry2LetterCode: localData?.taxCountry2LetterCode,
        taxState2LetterCode: localData?.taxState2LetterCode,
        taxZipCode: localData?.taxZipCode,
        taxID: localData?.taxID,
    });
};
